import axios from "axios"
import messages from '../components/message/message'
import redirect from '../components/redirect/redirect'

function validator(error, ...params)
{
    var message = error?.response?.data?.message ?? "There has been an error connecting to the server."

    if (!window.navigator.onLine) {
        message = "You don't appear to be online."
    }

    return Promise.resolve({data: {
        valid: false,
        message: message
    }})
}
const api = axios.create({
    headers: { Pragma: 'no-cache' },
  });

export default {
    get : (...params) =>
    {
        return api.get(...params)
        .catch((err) => validator(err, ...params))
    },

    post : (...params) =>
    {
        return api.post(...params)
        .catch((err) => validator(err, ...params))
    },

    put:  (...params) => {
        return api.put(...params)
        .catch((err) => validator(err, ...params))
    },

    delete: (...params) => {
        return api.delete(...params)
        .catch((err) => validator(err, ...params))
    },
    axios: api
}
